import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * This component renders sitemap.xml content as XML
 * Uses a pre tag to display content without any styling
 */
const SitemapXml = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSitemapXml = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/sitemap.xml`, {
          headers: {
            'Accept': 'application/xml'
          }
        });
        setContent(response.data);
      } catch (err) {
        console.error("Error fetching sitemap.xml:", err);
        // Fallback content
        setContent(`<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://kokanhomestays.in/</loc>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
</urlset>`);
      } finally {
        setLoading(false);
      }
    };

    fetchSitemapXml();
  }, []);

  // Remove all styles and render as plain XML
  useEffect(() => {
    // Hide all other elements and show only content
    document.body.style.margin = '0';
    document.body.style.padding = '8px';
    document.body.style.fontFamily = 'monospace';
    document.body.style.fontSize = '14px';
    document.body.style.backgroundColor = 'white';
    document.body.style.color = 'black';
    
    // Remove any injected styles
    const styleSheets = document.querySelectorAll('link[rel="stylesheet"]');
    styleSheets.forEach(sheet => sheet.remove());
    
    // Set content type meta tag
    let meta = document.querySelector('meta[http-equiv="Content-Type"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.httpEquiv = 'Content-Type';
      document.head.appendChild(meta);
    }
    meta.content = 'application/xml; charset=utf-8';
    
    // Update title
    document.title = 'sitemap.xml';
    
    return () => {
      // Cleanup not needed as page will reload on navigation
    };
  }, []);

  if (loading) {
    return null;
  }

  // Render as plain XML text
  return (
    <pre style={{
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      fontSize: '14px',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }}>
      {content}
    </pre>
  );
};

export default SitemapXml;
